// eslint-disable-next-line no-shadow
enum SaleType {
  TICKET,
  PRODUCT,
}
export default SaleType;
